export default __webpack_public_path__ + "static/media/kitchen3-afterG-1024w.28ddc8e6.png";